
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#92929b","stroke":"#92929b","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#92929b","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2069-1765.196a1.271 1.271 0 00.5-.1 1.362 1.362 0 00.444-.322l6.986-7.126a1.159 1.159 0 00.332-.84 1.218 1.218 0 00-.156-.616 1.2 1.2 0 00-.435-.439 1.152 1.152 0 00-.6-.166 1.207 1.207 0 00-.879.381l-6.192 6.367-6.191-6.367a1.186 1.186 0 00-.879-.381 1.144 1.144 0 00-.605.166 1.2 1.2 0 00-.586 1.055 1.142 1.142 0 00.342.84l6.972 7.128a1.253 1.253 0 00.439.322 1.307 1.307 0 00.508.098z"}})])])
          )
        }
      }
    